<template>
	<f7-fab position="right-bottom" href="/newTask/" class="ttip" ttipText="Создать чето">
		<span class="msr">edit</span>
	</f7-fab>
</template>

<script setup>

</script>